import { ThunkAction } from 'redux-thunk';

import { IRootState } from '../root_reducer';

import { NewArrivalsApi } from 'providers/NewArrivalsApi';

export interface NewArrivalsReduxState {
    isFetchingNewArrivals: boolean;
    newArrivals: any[];
}

export interface NewArrivalsReduxStateAction {
    type: string;
    response_data: any;
}
const initialState: NewArrivalsReduxState = {
    isFetchingNewArrivals: false,
    newArrivals: null
};

const NEW_ARRIVALS_FETCH = 'NEW_ARRIVALS/FETCH';
const NEW_ARRIVALS_SUCCESS = 'NEW_ARRIVALS/SUCCESS';
const NEW_ARRIVALS_FAILED = 'NEW_ARRIVALS/FAILED';

export const NewArrivalsReducer =  (state: NewArrivalsReduxState = initialState, action: NewArrivalsReduxStateAction): NewArrivalsReduxState => {
    switch (action.type) {
        case NEW_ARRIVALS_FETCH:
            return { ...state, isFetchingNewArrivals: true, newArrivals: null };
        case NEW_ARRIVALS_SUCCESS:
            return { ...state, isFetchingNewArrivals: false, newArrivals: action.response_data };
        case NEW_ARRIVALS_FAILED:
            return { ...state, isFetchingNewArrivals: false, newArrivals: [] };
        default:
            return state;
    }
};

export const getNewArrivals = (): ThunkAction<void, IRootState, null, any> => (dispatch) => {
    // tslint:disable-next-line
    dispatch({ type: NEW_ARRIVALS_FETCH });
    try {
        NewArrivalsApi.getNewArrivals().then((response_data: any) => {
            // tslint:disable-next-line
            const raw_data  = response_data.data;
            dispatch({ type: NEW_ARRIVALS_SUCCESS, response_data: raw_data });
        });
    } catch (error) {
        dispatch({ type: NEW_ARRIVALS_FAILED });  // TODO - this probably needs to be better
    }

};



// WEBPACK FOOTER //
// ./src/redux/modules/NewArrivals.ts